<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main" style="padding-bottom:0;" v-if="!empty">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>场景联动</span>
          <el-button style="float: right;" v-if="multipleSelection.length == 0" type="primary"
            @click="enableDialog=true">创建
          </el-button>
        </div>
      </div>
      <div class="coreMain">
        <div>
          <label>策略</label>
          <el-input class="input-with-select" placeholder="搜索" v-model="search" @keyup.enter.native="searchBtn"
            maxlength="100"></el-input>
          <el-select v-model="enable" clearable placeholder="状态" @change="changeEnable">
            <el-option v-for="item in enableList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button @click="searchBtn" slot="append" icon="el-icon-search" type="primary"></el-button>
          <el-button class="clearSearch" type="text" @click="reset">清除搜索条件</el-button>
        </div>
        <div class="myprotocol">
          <p v-if="strategyList.length == 0" style="font-size:15px;font-weight:bold;line-height:80px;margin-left:30px;">
            没有此数据
          </p>
          <ul class="formRow clearfix" v-if="strategyList.length != 0">
            <li v-for="(val, index) in strategyList" :key="index">
              <div>
                <el-card :class="val.enable==1?'enableRow':val.enable==0?'stoppedRow':''"
                  @click.native="detailBtn(val.id)">
                  <label>{{ val.name }}</label> <br />
                  <span>{{ val.count}}条规则</span>
                  <span style="float: right;">{{ val.enable==1?'启用':val.enable==0?'停用':'未知'}}</span>
                  <el-dropdown class="briefDetails" v-if="!val.flag" @command="command">
                    <span class="el-dropdown-link">
                      <i class="el-icon-more"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="{ type: 'edit', id: val.id }">编辑
                      </el-dropdown-item>
                      <el-dropdown-item :command="{ type: 'del', id: val.id }">删除
                      </el-dropdown-item>
                      <el-dropdown-item v-if="val.enable === 1" :command="{ type: 'stop', id: val.id }">停用
                      </el-dropdown-item>
                      <el-dropdown-item v-if="val.enable === 0" :command="{ type: 'start', id: val.id }">启用
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-card>
              </div>
            </li>
          </ul>
        </div>
        <el-pagination v-if="this.strategyList.length!=0" small style="text-align: left;padding:0 0 15px 0;"
          layout="total, prev, pager, next" :total="total" :current-page="currentPage" :page-size="pageSize"
          @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
    <!-- 没有策略显示的内容 -->
    <div class="emptyMain" v-if="empty">
      <el-card class="box-card">
        <img src="../../assets/images/celue.png" alt="" />
        <p style="color:#303133">您还没有创建任何策略</p>
        <br />
        <el-button>了解详情</el-button>
        <el-button type="primary" @click="enableDialog=true">创建策略</el-button>
      </el-card>
    </div>
    <!-- 创建策略 -->
    <el-dialog class="floorDialog" :show-close="false" title="创建策略" :visible.sync="enableDialog" width="400px">
      <el-form :model="enableForm" ref="enableForm">
        <el-form-item label="策略名称" style="background-color:transparent;border-bottom:none" prop="name"
          :rules="[{ required: true, message: '策略名称不能为空'}]">
          <el-input v-model="enableForm.name" placeholder='请输入' autocomplete="off" style="margin-top:5px;width:100%;"
            maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item prop="instruction" label="策略说明" style="background-color:transparent;border-bottom:none">
          <el-input style="margin-top:5px;width:100%;" type="textarea" :rows="3" v-model="enableForm.instruction"
            placeholder="请输入" maxlength="1024"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="enableDialog = false">取 消</el-button>
        <el-button type="primary" @click="addBtn('enableForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改策略 -->
    <el-dialog class="floorDialog" :show-close="false" title="修改策略" :visible.sync="editEnableDialog" width="400px">
      <el-form :model="editEnableForm" ref="editEnableForm">
        <el-form-item label="策略名称" style="background-color:transparent;border-bottom:none" prop="name" :rules="[
                  { required: true, message: '策略名称不能为空'}
                ]">
          <el-input v-model="editEnableForm.name" placeholder='请输入' autocomplete="off"
            style="margin-top:5px;width:100%;" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="策略说明" style="background-color:transparent;border-bottom:none">
          <el-input style="margin-top:5px;width:100%;" type="textarea" :rows="3" v-model="editEnableForm.instruction"
            placeholder="请输入" maxlength="1024"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editEnableDialog = false">取 消</el-button>
        <el-button type="primary" @click="editBtn('editEnableForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from "../../api/api";

  export default {
    data() {
      return {
        empty: true, //控制数据为空展示空页面
        total: 0,
        currentPage: 1,
        pageSize: 40,
        search: "", //搜索
        enable: '', //状态
        enableList: [{
            label: '启用',
            value: 1
          },
          {
            label: '停用',
            value: 0
          }
        ],
        enableForm: {}, //创建策略数据
        enableDialog: false, //创建策略弹框
        editEnableForm: {}, //修改策略数据
        editEnableDialog: false, //修改策略弹框
        strategyList: [], //策略
        multipleSelection: [] //策略-选中的值
      };
    },
    created() {},
    methods: {
      //获取策略数据
      getpageList() {
        let para = {
          name: this.search, //搜索栏
          enable: this.enable,
          pageSize: this.pageSize,
          currentPage: this.currentPage
        }
        API.platformRuleStrategyPage(para).then(res => {
          if (res.code == 1) {
            if (res.data.resultPage.length == 0) {
              this.empty = true; //没有数据显示空页面
            } else if (this.empty) {
              this.empty = false; //没有数据显示空页面
            }
            this.strategyList = res.data.resultPage
            this.total = res.data.total
          }
        })
      },
      //搜索功能
      searchBtn() {
        // this.enable = "",
        this.getpageList();
      },
      //状态切换搜索
      changeEnable() {
        // this.search = ""; //清空搜索条件
        this.getpageList();
      },
      //清除搜索条件
      reset() {
        this.search = ""
        this.enable = ""
        this.getpageList();
      },
      //操作
      operationBtn(val) {
        if (val.type == 'del') {
          let str = val.para.join(',')
          this.delBtn(str)
        }
      },
      //删除功能---批量删，单独删都能用
      delBtn(delID) {
        let para = {
          ids: delID
        }
        this.$confirm('此操作将永久删除该策略, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          API.delPlatformRuleStrategy(para).then(res => {
            if (res.code == 1) {
              this.$message.success('删除成功');
              this.getpageList()
            } else {
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //点击操作
      command(para) {
        let ids = para.id;
        if (para.type == "edit") {
          //编辑
          this.editDialog(ids)
        } else if (para.type == "del") {
          //删除
          this.delBtn(ids)
        } else if (para.type === "stop") {
          this.stop(ids, 0)
        } else if (para.type === "start") {
          this.stop(ids, 1)
        }
      },

      stop(id, enable) {
        API.platformRuleStrategyStop({
          ids: id,
          enable: enable
        }).then(res => {
          if (res.code === 1) {
            this.getpageList()
          } else {
            this.$message.error(res.msg)
          }
        })
      },

      //跳转详情页
      detailBtn(ids) {
        this.$router.push({
          path: "/rules/ruleEngineList",
          query: {
            id: ids
          }
        });
      },
      //创建策略
      addBtn(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            API.addPlatformRuleStrategy(this.enableForm).then(res => {
              if (res.code == 1) {
                this.$refs.enableForm.resetFields();
                this.$message.success('创建策略成功')
                this.getpageList()
                this.enableDialog = false;
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error('请填写完必填项')
            return false;
          }
        });
      },
      //弹出修改页面并获取当前策略的详情信息
      editDialog(id) {
        API.platformRuleStrategy(id).then(res => {
          if (res.code == 1) {
            this.editEnableForm = res.data
          }
        })
        this.editEnableDialog = true
      },
      //修改策略
      editBtn(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            API.editPlatformRuleStrategy(this.editEnableForm.id, this.editEnableForm).then(res => {
              if (res.code == 1) {
                this.$refs.editEnableForm.resetFields();
                this.$message.success('修改策略成功')
                this.getpageList()
                this.editEnableDialog = false;
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error('请填写完必填项')
            return false;
          }
        });
      },
      //分页
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getpageList()
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.getpageList()
      }
    },
    mounted() {
      this.getpageList()
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/sceneLinkage.vue